<template>
  <v-app>
    <navbar v-if="showToolbar" />
    <main :class="{ 'has-navbar': showToolbar }">
      <div class="corners">
        <div class="brand-logo" v-if="logoUrl">
          <a :href="brand.logo.redirectUrl">
            <img :src="logoUrl" v-fallback-src="'/static/Insta-logo-svg.svg'" alt="logo" />
          </a>
        </div>
        <div class="share-feedback primary--text" v-if="brand.feedbackUrl">
          <i18n path="app.feedback" tag="p">
            <template v-slot:link>
              <a :href="brand.feedbackUrl" class="blue--text">{{ $t('app.feedbackLink') }}</a>
            </template>
          </i18n>
        </div>
        <div class="copyright">
          <p>&copy; {{ brand.copyrightText }}</p>
        </div>
        <div class="locale-picker" v-if="!showToolbar">
          <locale-switcher button-class="primary--text" />
        </div>
      </div>
      <v-container>
        <v-layout class="layout">
          <v-flex xs12 md10 offset-md1>
            <router-view-with-error-and-loader />
          </v-flex>
        </v-layout>
      </v-container>
    </main>
    <notifications />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Navbar from '@/components/shared/Navbar';
import Notifications from '@/components/shared/Notifications';
import RouterViewWithErrorAndLoader from '@/components/shared/RouterViewWithErrorAndLoader';
import LocaleSwitcher from '@/components/shared/LocaleSwitcher';

export default {
  name: 'app',
  components: {
    Navbar,
    Notifications,
    RouterViewWithErrorAndLoader,
    LocaleSwitcher,
  },
  computed: {
    ...mapGetters(['logoUrl', 'brand', 'user']),
    showToolbar() {
      return this.user && !this.$route.meta.publicRoute;
    },
  },
  methods: {
    ...mapActions(['initialAutoLogIn']),
  },
  async mounted() {
    await this.initialAutoLogIn();
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}

/* NoVNC forces the client cursor to 'none' in Instance.vue, so we override it here
   This is the simplest way to keep the style scoping intact and still get the desired result */
.rfb-canvas-container > div > canvas {
  cursor: pointer !important;
  width: 100% !important;
  height: 100% !important;
}

.application {
  min-height: 100%;
}

main {
  position: relative;
  padding-bottom: 180px;
  min-height: 100vh;
}

main.has-navbar {
  min-height: calc(100vh - 56px);
}

.corners {
  bottom: 0;
  left: 0;
  position: absolute;
  width: 100%;
}

.copyright,
.share-feedback,
.locale-picker {
  text-align: center;
}

.brand-logo {
  margin: 0 auto 15px auto;
  max-width: 190px;
  width: calc(100% - 40px);
}

.brand-logo img {
  width: 100%;
}

.share-feedback {
  font-size: 1.15em;
}
/* .layout {
  flex-direction: row-reverse;
} */

@media screen and (min-width: 1024px) {
  main {
    padding-bottom: 65px;
  }

  .corners {
    position: static;
    width: 0;
    height: 0;
  }

  .brand-logo,
  .share-feedback,
  .copyright,
  .locale-picker {
    position: absolute;
  }

  .locale-picker {
    top: 20px;
    left: 20px;
  }

  .brand-logo {
    top: 20px;
    right: 50px;
    max-width: 170px;
  }

  .share-feedback {
    bottom: 20px;
    right: 20px;
  }

  .copyright {
    bottom: 5px;
    left: 20px;
  }
}
.theme--light.v-card > .v-card__text {
  color: black;
}
</style>
